import type { Map } from 'leaflet';
import { useEffect } from 'react';

export function useMapSizeInvalidation(map: Map | null, trigger: unknown) {
  useEffect(() => {
    if (map && trigger) {
      map.invalidateSize();
    }
  }, [map, trigger]);
}
